module.exports = ES6Promise;


//////////////////
// WEBPACK FOOTER
// external "ES6Promise"
// module id = YN8k
// module chunks = 233